<template>
  <div style="background: #25458c" class="slide-box">
  <v-container>
    <div  style="position: relative;top: 200px">
      <v-carousel
          v-if="slider.topics && slider.topics.length"
          height="60vh"
          hide-delimiter-background
          hide-delimiters
          :show-arrows="false"
          v-model="selectedImage"
          cycle
      >
        <v-carousel-item

        v-for="(item, i) in slider.topics"
            :key="i"
        >
          <v-img :src="item.photo_file" style="object-fit: fill" cover></v-img>
        </v-carousel-item>
      </v-carousel>
      <div class="dots-box-position d-flex flex-row justify-center align-center ">
        <v-row>
          <v-col class="d-flex justify-center align-center">
            <div style="color: #d4d4d4" class="d-flex mt-8">
            <v-icon class="ml-6" @click="selectedImage++" color="white">mdi-arrow-right</v-icon>
              <h6 class="mx-1 white--text">{{slider.topics.length}}</h6>
              /
              {{selectedImage + 1}}


            <v-icon class="mr-6" @click="selectedImage--" color="white">mdi-arrow-left</v-icon>
            </div>
          </v-col>
        </v-row>
      </div>

    </div>
  </v-container>

  </div>
</template>
<script>
import { mapState } from 'vuex';


export default {
  name: 'topSlider',
  data() {
    return {
      selectedImage: 0,
      stop: false
    }
  },
  computed:{
    ...mapState({
      slider: state => state.glassManagement.glassNewsSlider,
    })
  },
  created(){
    this.$store.dispatch('glassManagement/getGlassNewsSlider');
  }
}
</script>
<style scoped>


  .slide-box {
    background: rgba(0, 0, 0, 0.09);
    margin: 0;
    width: 100%;
    height: 900px;
  }

</style>